import { getOperationAST } from 'graphql';
import DataLoader from 'dataloader';
import { ValueOrPromise } from 'value-or-promise';
import { mergeExecutionParams } from './mergeExecutionParams';
import { splitResult } from './splitResult';
export function createBatchingExecutor(executor, dataLoaderOptions, extensionsReducer) {
    const loader = new DataLoader(createLoadFn(executor, extensionsReducer !== null && extensionsReducer !== void 0 ? extensionsReducer : defaultExtensionsReducer), dataLoaderOptions);
    return (executionParams) => loader.load(executionParams);
}
function createLoadFn(executor, extensionsReducer) {
    return async (execs) => {
        const execBatches = [];
        let index = 0;
        const exec = execs[index];
        let currentBatch = [exec];
        execBatches.push(currentBatch);
        const operationType = getOperationAST(exec.document, undefined).operation;
        while (++index < execs.length) {
            const currentOperationType = getOperationAST(execs[index].document, undefined).operation;
            if (operationType === currentOperationType) {
                currentBatch.push(execs[index]);
            }
            else {
                currentBatch = [execs[index]];
                execBatches.push(currentBatch);
            }
        }
        const executionResults = [];
        execBatches.forEach(execBatch => {
            const mergedExecutionParams = mergeExecutionParams(execBatch, extensionsReducer);
            executionResults.push(new ValueOrPromise(() => executor(mergedExecutionParams)));
        });
        return ValueOrPromise.all(executionResults).then(resultBatches => {
            let results = [];
            resultBatches.forEach((resultBatch, index) => {
                results = results.concat(splitResult(resultBatch, execBatches[index].length));
            });
            return results;
        }).resolve();
    };
}
function defaultExtensionsReducer(mergedExtensions, executionParams) {
    const newExtensions = executionParams.extensions;
    if (newExtensions != null) {
        Object.assign(mergedExtensions, newExtensions);
    }
    return mergedExtensions;
}
//# sourceMappingURL=createBatchingExecutor.js.map